// import { useEffect, useState } from "react";
// import { fetchState, fetchRegionandTerritory } from "../../../api/locationApi";
// import MantisDataTable from "../../../components/common/MantisDataTable";
// import { useNavigate } from "react-router";

// export default function TerritoryList() {
//   const navigate = useNavigate();
//   const [stateList, setStateList] = useState([]);
//   const [territory, setTerritory] = useState([]);
//   const [filters, setFilters] = useState({ stateDesc: "" });
//   const [loading, setLoading] = useState(false);

//   // Load states on mount
//   useEffect(() => {
//     const loadStates = async () => {
//       const states = await fetchState();
//       setStateList(states || []);
//     };
//     loadStates();
//   }, []);

//   // Handle filter changes
//   const handleFilterChange = (updatedFilters) => {
//     setFilters(updatedFilters);
//   };

//   // Fetch data based on selected state
//   const handleFilterSubmit = async () => {
//   setLoading(true);

//   try {
//   const stateValue = filters.stateDesc === "ALL" ? "All" : filters.stateDesc;


//     const data = await fetchRegionandTerritory(
//       stateValue,
//       "TERRITORY"
//     );

//     setTerritory(data || []);
//   } catch (err) {
//     console.error("Error fetching territory data:", err);
//     setTerritory([]);
//   } finally {
//     setLoading(false);
//   }
// };

//   const handleEdit = (territory) => {
//     navigate("/add-territory", { state: { territory } });
//   };

//   const handleAdd = () => {
//     navigate("/add-territory", { state: { territory } });
//   };

//   return (
//     <div className="space-y-6">
//       <MantisDataTable
//         title="Territory Master"
//         data={territory}
//         loading={loading}
//         columns={[
//           //    {
//           //   label: "Action",
//           //   key: "action",
//           //   type: "actions",
//           //   actions: [
//           //       {
//           //       type: "edit",
//           //       label: "View Details",
//           //       action: handleEdit,
//           //       },
//           //   ],
//           // },
//           { key: "code", label: "Code" },
//           { key: "name", label: "Name" },
//           { key: "state", label: "State" },
//           { key: "status", label: "Status", type: "badge" },
//         ]}
//         searchable
//         searchPlaceholder="Search by name/code"
//         onFilterChange={handleFilterChange}
//         onFilterSubmit={handleFilterSubmit}
//          filters={[
//   {
//     name: "stateDesc",
//     label: "State",
//     type: "select",
//     options: [  
//       { label: "All", value: "ALL" },       // ✅ Added
//       ...stateList.map((s) => ({
//         value: s.description,
//         label: s.description,
//       })),
//     ],
//   },
// ]}
//         showAddButton
//         onAdd={handleAdd}
//       />
//     </div>
//   );
// }




// TerritoryList.jsx
import { useEffect, useState } from "react";
import { fetchState, fetchRegionandTerritory } from "../../../api/locationApi";
import MantisDataTable from "../../../components/common/MantisDataTable";
import { useNavigate } from "react-router";

export default function TerritoryList() {
  const navigate = useNavigate();
  const [stateList, setStateList] = useState([]);
  const [territory, setTerritory] = useState([]);
  const [filters, setFilters] = useState({ stateDesc: "ALL" });
  const [loading, setLoading] = useState(false);

  // Load states + initial API call
  useEffect(() => {
    const init = async () => {
      const states = await fetchState();
      setStateList(states || []);
      fetchData("All"); // 🔥 auto load all on mount
    };
    init();
  }, []);

  const fetchData = async (stateValue) => {
    setLoading(true);
    try {
      const data = await fetchRegionandTerritory(stateValue, "TERRITORY");
      setTerritory(data || []);
    } catch (err) {
      console.error("Error fetching territory data:", err);
      setTerritory([]);
    } finally {
      setLoading(false);
    }
  };

  // Auto fetch when filter changes
  const handleFilterChange = (updatedFilters) => {
    setFilters(updatedFilters);

    const stateValue =
      updatedFilters.stateDesc === "ALL" ? "All" : updatedFilters.stateDesc;

    fetchData(stateValue); // 🔥 auto call API (no apply button)
  };

  const handleEdit = (territory) => {
    navigate("/add-territory", { state: { territory } });
  };

  const handleAdd = () => {
    navigate("/add-territory");
  };

  return (
    <div className="space-y-6">
      <MantisDataTable
        title="Territory Master"
        data={territory}
        loading={loading}
        columns={[
          { key: "code", label: "Code" },
          { key: "name", label: "Name" },
          { key: "state", label: "State" },
          { key: "status", label: "Status", type: "badge" },
        ]}
        searchable
        searchPlaceholder="Search by name/code"
        onFilterChange={handleFilterChange}
        filters={[
          {
            name: "stateDesc",
            label: "State",
            type: "select",
            options: [
              { label: "All", value: "ALL" },
              ...stateList.map((s) => ({
                value: s.description,
                label: s.description,
              })),
            ],
          },
        ]}
        showAddButton
        onAdd={handleAdd}
      />
    </div>
  );
}
